import React, { useState } from 'react'
import { Row, Col, Form, Button, Tooltip } from 'antd'
import PasswordField from 'components/Password'
import { BUTTONS, LOGIN_PAGE } from 'constants/constants'
import { InfoCircleOutlined } from '@ant-design/icons'
import { useHistory } from 'react-router-dom'
import forge from "node-forge";
import { useActions } from '../../../../../hooks/useActions'
import { getPasswordChangeData } from 'store/actions/login'
import CustomNotifocation from 'components/CustomNotification'
import { secureLocalStorageGet } from '../../../../../helpers'
import { API_URL } from '../../../../../services/config/index'
import { connect } from 'react-redux'
import { v4 as uuidv4 } from 'uuid';
import '../sidebar.scss'
import { useTranslation } from 'react-i18next'
import axios from 'axios'


const PasswwordChange: React.FC = (props:any) => {

  const {t} = useTranslation();

  const passwordFields: Array<any> = [
    {
      id: 1,
      size: 'large',
      placeholder: t("login.currentPassword"),
      fieldName: 'InputField',
      name: 'oldPassword',
      type: 'password',
    },
    {
      id: 2,
      size: 'large',
      placeholder: t("login.newPassword"),
      fieldName: 'InputField',
      name: 'newPassword',
      type: 'password',
    },
    {
      id: 3,
      size: 'large',
      placeholder: t("login.repeatPassword"),
      fieldName: 'InputField',
      name: 'newPasswordRepeat',
      type: 'password',
    },
  ]

  const history = useHistory()
  const { changeRoute } = useActions()
  const [form] = Form.useForm()
  const { getPasswordChangeData } = useActions()

  const [errorMessage, setErrorMessage] = useState('')
  const [notify, setNotify] = useState(false)

  const handleRouteChange = () => {
    secureLocalStorageGet('channel') == 'OTP' ? changeRoute(2) : changeRoute(1)
  }
  const closeNotification = () => {
    setNotify(false)
  }
  const spkiBase64ToPem = (spkiB64: string) => {
        const clean = spkiB64.replace(/\s+/g, "");
        const lines = clean.match(/.{1,64}/g)?.join("\n") ?? clean;
        return `-----BEGIN PUBLIC KEY-----\n${lines}\n-----END PUBLIC KEY-----`;
      };
      
      const encryptPasswordDevglan = (password: string, publicKeySpkiBase64: string) => {
        const pem = spkiBase64ToPem(publicKeySpkiBase64);
        const pubKey = forge.pki.publicKeyFromPem(pem);
      
        const encryptedBytes = pubKey.encrypt(password, "RSA-OAEP", {
          md: forge.md.sha256.create(),
          mgf1: {
            md: forge.md.sha1.create(),
          },
        });
      
        return forge.util.encode64(encryptedBytes);
      };
      const validatePasswords = ({ newPassword, newPasswordRepeat }: any) => {
  if (newPassword !== newPasswordRepeat) {
    setErrorMessage(t("settings.passwordNotSame"));
    setNotify(true);
    return false;
  }
  return true;
};

  const onFinishPasswordChange = async (args: any) => {
    const oldPassword = args.oldPassword
    const newPassword = args.newPassword
    const strongRegex = new RegExp(
      '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*?])(?=.{8,})'
    )
    if (!validatePasswords(args)) return;
    if (!oldPassword || !newPassword) {
      if (!newPassword) {
        setNotify(true)
        setErrorMessage(t("login.fillNewPassword"))
      }
      if (!oldPassword) {
        setNotify(true)
        setErrorMessage(t("login.fillPasswordField"))
      }
    } else if (oldPassword.length < 8 || newPassword.length < 8) {
      if (newPassword.length < 8) {
        setNotify(true)
        setErrorMessage(t("login.newPassword8Symbol"))
      }

      if (oldPassword.length < 8) {
        setNotify(true)
        setErrorMessage(t("login.password8Symbol"))
      }
    } else if (oldPassword.length > 20 || newPassword.length > 20) {
      if (newPassword.length > 20) {
        setNotify(true)
        setErrorMessage(t("login.newPassword20Symbol"))
      }

      if (oldPassword.length > 20) {
        setNotify(true)
        setErrorMessage(t("login.password20Symbol"))
      }
    } else if (!strongRegex.test(newPassword) || !strongRegex.test(newPassword)) {
      if (!strongRegex.test(newPassword)) {
        setNotify(true)
        setErrorMessage(t("settings.newPasswordLetterNumberSymbol"))
      }
      if (!strongRegex.test(oldPassword)) {
        setNotify(true)
        setErrorMessage(t("settings.newPasswordLetterNumberSymbol"))
      }
    } else {
  const encryptPasswordWithFreshNonceAndKey = async (password: string) => {
    const pkResp = await axios.get(`${API_URL}auth/get-ldap-public-key`);
    const publicKeyB64 = pkResp?.data?.publicKey;

    if (!publicKeyB64) throw new Error("publicKey gəlmədi");

    const timestamp = pkResp?.data?.serverDate.toString()
    //  Math.floor(Date.now() / 1000).toString();
    const nonce = uuidv4();
    const passwordPayload = `${timestamp}${nonce}${password}`;

    return encryptPasswordDevglan(passwordPayload, publicKeyB64);
  };

  const oldPasswordEnc = await encryptPasswordWithFreshNonceAndKey(args.oldPassword);

  let newPasswordEnc: any;
  let newPasswordRepeatEnc: any;

  if (args.newPassword === args.newPasswordRepeat) {
    newPasswordEnc = await encryptPasswordWithFreshNonceAndKey(args.newPassword);
    newPasswordRepeatEnc = await encryptPasswordWithFreshNonceAndKey(args.newPasswordRepeat);
  }

  const PostData = {
    userName: secureLocalStorageGet("username"),
    oldPassword: oldPasswordEnc,
    newPassword: newPasswordEnc,
    newPasswordRepeat: newPasswordRepeatEnc,
    // authType: props.tabValue == 2 ? 'TOTP' : 'OTP'
  };

  getPasswordChangeData(
    PostData,
    { authType: props.tabValue == 2 ? "TOTP" : "OTP" },
    history
  );
}
  }
  const text = (
    <div className="ant-tooltip-inner__data">
      <p>
        {t("login.passwordSpecialSymbols") + ': `! @ # $% ^ & * () _ = + - [] {}; : "|,. <>  /?`'}
      </p>
    </div>
  )

  return (
    <Row>
      {notify && <CustomNotifocation message={errorMessage} />}
      <Col className="login-form login-form--office-card">
        <h3>{t(LOGIN_PAGE.CHANGE_PASSWORD_TITLE)}</h3>
        <Form
          form={form}
          name="passwordChange"
          onSubmit={(e) => e.preventDefault()}
          onFinish={onFinishPasswordChange}
          onBlur={closeNotification}
          autoComplete="off"
        >
          {passwordFields.map((item: any ,index) => {
            return (
              <div key={index} className="password-field">
                {item.id == 2 ? (
                  <div style={{ position: 'relative' }}>
                    <PasswordField
                      type={item.type}
                      label={item.placeholder}
                      size={item.size}
                      form={form}
                      name={item.name}
                    />
                    <Tooltip title={text} placement="bottom">
                      <InfoCircleOutlined
                        style={{ color: '#223142' }}
                        id="password-notification"
                      />
                    </Tooltip>
                  </div>
                ) : (
                  <PasswordField
                    type={item.type}
                    form={form}
                    label={item.placeholder}
                    size={item.size}
                    name={item.name}
                  />
                )}
              </div>
            )
          })}
          <div className="login-form__buttons">
            <Row>
              <Button
                size={'large'}
                className="prev"
                onClick={handleRouteChange}
              >
                {BUTTONS.BACK_BUTTON}
              </Button>
              <Button size={'large'} className="next blue" htmlType="submit">
                {BUTTONS.NEXT_BUTTON}
              </Button>
            </Row>
          </div>
        </Form>
      </Col>
    </Row>
  )
}
const mapDispatchToProps = { getPasswordChangeData }

const mapStateToProps = (state: any) => ({
  tabValue: state.login && state.login.tabValue,
})

export default connect(mapStateToProps, mapDispatchToProps)(PasswwordChange)
